import {
  Input,
  Button,
  Radio,
  DatePicker,
  Alert,
  Badge,
  Popover,
  Select,
  Row,
  Col,
  Checkbox,
  Slider,
} from 'antd';
import { BsQuestionCircleFill } from 'react-icons/bs';
import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { PieChart } from 'react-minimal-pie-chart';
import { BulbFilled } from '@ant-design/icons';
import LocationInput from './LocationInput';
import PasswordField from '../../components/AuthModal/PasswordField';

const { Option } = Select;
const { TextArea } = Input;

// Option-card icon set (from the Assessment Flow design). Stroked with
// currentColor so each card tints the icon via its accent color.
const OPT_ICONS = {
  check: (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5L20 7" /></svg>
  ),
  fat: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2c1 4 5 5 5 10a5 5 0 1 1-10 0c0-2 1-3 2-4 0 2 1 3 3 3-2-3 0-6 0-9z" /></svg>
  ),
  muscle: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9v6M5 6v12M9 4v16M15 4v16M19 6v12M22 9v6" /></svg>
  ),
  recomp: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></svg>
  ),
  health: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" /></svg>
  ),
  male: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="10" cy="14" r="6" /><path d="M14.5 9.5 20 4M15 4h5v5" /></svg>
  ),
  female: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="9" r="6" /><path d="M12 15v7M9 19h6" /></svg>
  ),
  apple: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 7c1-2 3-3 5-3 0 2-1 4-3 5" /><path d="M17 9c2 0 4 2 4 5 0 4-3 8-6 8-1 0-2-.5-3-.5s-2 .5-3 .5c-3 0-6-4-6-8 0-3 2-5 4-5 1 0 2 .5 3 .5s2-.5 3-.5z" /></svg>
  ),
  bolt: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m13 2-9 12h7l-1 8 9-12h-7z" /></svg>
  ),
  target: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></svg>
  ),
};

// Per-option accent + icon, keyed by question type then option value.
const OPT_META = {
  goal: {
    'Lose body fat': { icon: 'fat', color: '#ef4444' },
    'Gain muscle': { icon: 'muscle', color: '#8b5cf6' },
    'Body recomposition': { icon: 'recomp', color: '#06b6d4' },
    'Improve overall health': { icon: 'health', color: '#10b981' },
  },
  gender: {
    male: { icon: 'male', color: '#3b82f6' },
    female: { icon: 'female', color: '#ec4899' },
  },
  foodPreference: {
    anything: { icon: 'apple', color: '#10b981' },
    keto: { icon: 'bolt', color: '#f59e0b' },
    paleo: { icon: 'fat', color: '#ef4444' },
    vegetarian: { icon: 'health', color: '#8b5cf6' },
    vegan: { icon: 'target', color: '#06b6d4' },
  },
};

// Category eyebrow shown above each question title (from the design).
const EYEBROW = {
  age: 'About you',
  weight: 'About you',
  height: 'About you',
  gender: 'About you',
  activityLevel: 'About you',
  goal: 'Your goal',
  foodPreference: 'Nutrition',
  macros: 'Nutrition',
  newPassword: 'Almost done',
};

// const marks = {
//   0: 'Beginner',
//   50: 'Intermediate',
//   100: 'Advanced',
// };

export const AssessmentQuestions = (props) => {
  const [error, setError] = useState(null);
  const [termsOfWeightTraningexprience, setTermsOfWeightTraningexprience] =
    useState(null);
  let currentDate = new Date();
  const monthsOptions = [
    { value: 0, text: 'January' },
    { value: 1, text: 'February' },
    { value: 2, text: 'March' },
    { value: 3, text: 'April' },
    { value: 4, text: 'May' },
    { value: 5, text: 'June' },
    { value: 6, text: 'July' },
    { value: 7, text: 'August' },
    { value: 8, text: 'September' },
    { value: 9, text: 'October' },
    { value: 10, text: 'November' },
    { value: 11, text: 'December' },
  ];
  const heigthFtOptions = [
    { value: '1' },
    { value: '2' },
    { value: '3' },
    { value: '4' },
    { value: '5' },
    { value: '6' },
    { value: '7' },
    { value: '8' },
    { value: '9' },
  ];
  const heigthInOptions = [
    { value: '0' },
    { value: '1' },
    { value: '2' },
    { value: '3' },
    { value: '4' },
    { value: '5' },
    { value: '6' },
    { value: '7' },
    { value: '8' },
    { value: '9' },
    { value: '10' },
    { value: '11' },
  ];
  const [selDate, setSelDate] = useState(
    props.responseObj.birthday
      ? new Date(props.responseObj.birthday.value)
      : null
  );
  const [selMonth, setSelMonth] = useState(-1);
  const [selDay, setSelDay] = useState(-1);
  const [selYear, setSelYear] = useState(-1);

  // let startYear = currentDate.getFullYear() - 18;
  let startYear = moment(currentDate).subtract(18, 'years').format('YYYY');
  let endYear = currentDate.getFullYear() - 100;
  let yearsOptions = [];
  for (let i = startYear; i >= endYear; i--) yearsOptions.push(i);

  const daysInMonth = (month, year) => {
    return new Date(year, parseInt(month) + 1, 0).getDate();
  };
  let days = daysInMonth(selMonth, selYear);
  let daysOptions = [];
  for (let i = 1; i <= days; i++) daysOptions.push(i);

  const handleMonthChange = async (value) => {
    await setSelMonth(value);
  };

  const handleYearChange = async (value) => {
    await setSelYear(parseInt(value));
  };

  const handleDayChange = async (value) => {
    await setSelDay(value);
  };

  const validateBirthDate = () => {
    // selMonth arrives from the month dropdown as a string ('0'–'11'), so the
    // old `${selMonth + 1}` concatenated instead of adding (e.g. '5' + 1 = '51'
    // -> "2000-51-16" -> invalid date -> age fell back to 1 -> the button stayed
    // disabled for every month except Jan/Feb). Build the date numerically.
    const y = parseInt(selYear, 10);
    const m = parseInt(selMonth, 10); // 0-indexed month
    const d = parseInt(selDay, 10);
    if (isNaN(y) || isNaN(m) || isNaN(d)) {
      return 1;
    }
    const age = moment().diff(moment(new Date(y, m, d)), 'years', false);
    return age ? age : 1;
  };

  /* useEffect(()=>{
    if(selDay != -1 && selMonth != -1 && selYear != -1) {
      validateBirthDate();
    }
  }, [selDate, selDay, selMonth, selYear]); */

  useEffect(() => {
    setSelMonth(selDate ? selDate.getMonth() : -1);
    setSelDay(selDate ? selDate.getDate() : -1);
    setSelYear(selDate ? selDate.getFullYear() : -1);
  }, [selDate]);

  useEffect(() => {
    const handleDateChange = async () => {
      if (selMonth !== -1 && selDay !== -1 && selYear !== -1) {
        const age = await validateBirthDate();
        if (age >= 18 && age <= 100) {
          let newDate = new Date(selYear, selMonth, selDay);
          if (newDate.getTime() > currentDate.getTime()) {
            newDate = currentDate;
          }
          setSelMonth(newDate ? newDate.getMonth() : -1);
          setSelDay(newDate ? newDate.getDate() : -1);
          setSelYear(newDate ? newDate.getFullYear() : -1);
          props.handleChange(newDate, 'birthday');
          // Only touch the shared `error` state when the birthday question is
          // the one on screen. selDate is seeded from props.responseObj.birthday,
          // so after a page refresh this effect runs on whatever question was
          // restored (e.g. gender) and would otherwise wipe THAT question's
          // validation error — letting the user Next past an unanswered question.
          if (props.activeQuestion.type === 'age') {
            setError(null);
          }
        } else if (props.activeQuestion.type === 'age') {
          setError('Age should be higher than 18 and lower than 100');
        }
      }
    };
    if (selMonth !== -1 && selDay !== -1 && selYear !== -1) {
      handleDateChange();
    }
  }, [selMonth, selDay, selYear]);

  useEffect(() => {
    setError(null);
    const type =
      props.activeQuestion.type === 'height'
        ? 'heightFt'
        : props.activeQuestion.type;
    if (props.activeQuestion.type === 'weightTraningexprience') {
      setError(null);
    } else if (!props.responseObj[type]) {
      setError('All fields are required');
    }
  }, [props.activeQuestion.type]);

  // Press Enter to advance when the current question is valid (mirrors the
  // assessment design's "Press Enter" affordance). Skipped while a textarea is
  // focused (Enter = newline), while a Select dropdown is open (Enter picks an
  // option), and on the Back button (so Enter there still goes back).
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Arrow Up/Down: move the selection on single-select option-card questions
      // (goal / sex / food / activity) so the step is fully keyboard-driven.
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const q = props.activeQuestion;
        const tag = e.target && e.target.tagName;
        if (
          !q ||
          !Array.isArray(q.options) ||
          q.hasOwnProperty('component') ||
          tag === 'INPUT' ||
          tag === 'TEXTAREA' ||
          tag === 'SELECT'
        ) {
          return;
        }
        if (
          document.querySelector(
            '.ant-select-dropdown:not(.ant-select-dropdown-hidden)'
          )
        ) {
          return;
        }
        e.preventDefault();
        const opts = q.options;
        const cur = opts.findIndex((o) => o.active);
        let next;
        if (e.key === 'ArrowDown') {
          next = cur < 0 ? 0 : Math.min(cur + 1, opts.length - 1);
        } else {
          next = cur < 0 ? opts.length - 1 : Math.max(cur - 1, 0);
        }
        const option = opts[next];
        props.handleChange(option, q.type);
        setError(q.validate(option.macros, option.text));
        return;
      }
      if (e.key !== 'Enter') return;
      if (e.target && e.target.tagName === 'TEXTAREA') return;
      if (e.target && e.target.closest && e.target.closest('.assessment-back-btn'))
        return;
      if (
        document.querySelector(
          '.ant-select-dropdown:not(.ant-select-dropdown-hidden)'
        )
      ) {
        return;
      }
      if (Boolean(error) || props.auth.assessmentSubmitLoader) return;
      e.preventDefault();
      props.handleProgress(e, null, props.activeQuestion);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [error, props.activeQuestion, props.auth.assessmentSubmitLoader]);

  const checkIfDisabled = () => {
    return Boolean(error);
  };

  const renderQuestion = () => {
    // Custom (trainer-built) questions use the question text as both the title
    // and the per-field label, so hide the form-name for them (and for any
    // question that opts in via hideFormName) to avoid showing it twice.
    const shouldHideFormName =
      props.activeQuestion.hideFormName || props.activeQuestion.custom;
    if (props.activeQuestion.hasOwnProperty('component')) {
      return props.activeQuestion.component
        .filter((item) => {
          if (item.units) {
            return item.units === props.units;
          }
          return true;
        })
        .map((component) => {
          const componentType = component.type === 'weightTraningexprience' ? 'SliderSelect' : component.type === 'CustomPieChart' ? 'MacroSelect' : component.type;
          return component.render.map((render) => {
            if (componentType === 'Input') {
              return (
                <div style={{ display: !render.active ? 'none' : '' }}>
                  <div className='flex flex-center-aligned'>
                    {!shouldHideFormName && (
                    <p className='form-name'>{render.type}</p>
                  )}
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          style={{ display: !render.popover && 'none' }}
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          <BulbFilled
                            style={{
                              fontSize: '18px',
                              color: '#BDBDBD',
                              margin: '0 0 1px 3px',
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <div
                    className='flex flex-center-aligned'
                    style={{ marginBottom: 10 }}
                  >
                    <Input
                      type={render.inputType ? render.inputType : 'text'}
                      className={render.className}
                      key={render.type}
                      autoFocus={render.autoFocus}
                      maxLength={render.maxLength}
                      onChange={(e) => {
                        props.handleChange(e, render.value);
                        setError(
                          render.validate(
                            e.target.value,
                            props.units,
                            render.value === 'goalWeight'
                              ? props.responseObj.byWhen
                              : render.value === 'heightFt'
                              ? props.responseObj.heightIn
                              : props.responseObj.heightFt
                          )
                        );
                      }}
                      defaultValue={
                        props.responseObj[render.value] &&
                        props.responseObj[render.value].value
                      }
                    />
                    <Radio.Group
                      value='large'
                      className='flex'
                      style={{
                        display: render.type === 'Height in.' ? 'none' : '',
                      }}
                    >
                      {component.addOnAfter &&
                        (component.addOnAfter.type !== 'one' ? (
                          component.addOnAfter.keys.map((measure) => {
                            return (
                              <Radio.Button
                                className={measure.className}
                                style={{
                                  background:
                                    measure.units === props.units
                                      ? 'var(--primary, #8b5cf6)'
                                      : '#fff',
                                  color:
                                    measure.units === props.units
                                      ? '#fff'
                                      : 'var(--primary, #8b5cf6)',
                                  fontWeight: '500',
                                }}
                                onClick={props.handleMeasureValue}
                                key={measure.units}
                                value={measure.units}
                              >
                                {measure.key}
                              </Radio.Button>
                            );
                          })
                        ) : (
                          <Radio.Button
                            className='border-right'
                            style={{
                              background: 'var(--primary, #8b5cf6)',
                              color: '#fff',
                            }}
                          >
                            {
                              component.addOnAfter.keys.find(
                                (el) => el.units === props.units
                              ).key
                            }
                          </Radio.Button>
                        ))}
                    </Radio.Group>
                  </div>
                </div>
              );
            } else if (componentType === 'DatePickerBirthday') {
              return (
                <div style={{ display: !render.active ? 'none' : '' }}>
                  <div className='flex flex-center-aligned'>
                    {!shouldHideFormName && (
                    <p className='form-name'>{render.type}</p>
                  )}
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          {/* <BsQuestionCircleFill style={{ fontSize: '12px', margin: '0 0 1px 3px' }} /> */}
                          <BulbFilled
                            style={{
                              fontSize: '18px',
                              color: '#BDBDBD',
                              margin: '0 0 1px 3px',
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <Row gutter={16}>
                    <Col sm={8} className='gutter-row'>
                      <Select
                        style={{ width: '100%', marginBottom: '10px' }}
                        placeholder='Month'
                        className='select-input'
                        onChange={(value) => {
                          handleMonthChange(value);
                        }}
                        value={selMonth != -1 ? selMonth : undefined}
                      >
                        {monthsOptions.map((month, i) => (
                          <Option
                            className='select-option'
                            key={i}
                            value={month.value}
                          >
                            {month.text}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                    <Col sm={8} className='gutter-row'>
                      <Select
                        style={{ width: '100%', marginBottom: '10px' }}
                        placeholder='Day'
                        className='select-input'
                        onChange={(value) => {
                          handleDayChange(value);
                        }}
                        value={selDay != -1 ? selDay : undefined}
                      >
                        {daysOptions.map((day) => (
                          <Option
                            className='select-option'
                            key={day}
                            value={day}
                          >
                            {day}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                    <Col sm={8} className='gutter-row'>
                      <Select
                        style={{ width: '100%', marginBottom: '10px' }}
                        placeholder='Year'
                        className='select-input'
                        onChange={(value) => {
                          handleYearChange(value);
                        }}
                        value={selYear != -1 ? selYear : undefined}
                      >
                        {yearsOptions.map((year) => (
                          <Option
                            className='select-option'
                            key={year}
                            value={year}
                          >
                            {year}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                  </Row>
                </div>
              );
            } else if (componentType === 'DatePicker') {
              return (
                <div style={{ display: !render.active ? 'none' : '' }}>
                  <div className='flex flex-center-aligned'>
                    {!shouldHideFormName && (
                    <p className='form-name'>{render.type}</p>
                  )}
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          {/* <BsQuestionCircleFill style={{ fontSize: '12px', margin: '0 0 1px 3px' }} /> */}
                          <BulbFilled
                            style={{
                              fontSize: '18px',
                              color: '#BDBDBD',
                              margin: '0 0 1px 3px',
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <div
                    className='flex flex-center-aligned'
                    style={{ marginBottom: '10px' }}
                  >
                    <DatePicker
                      placeholder={''}
                      style={{ width: '100%' }}
                      key={render.type}
                      disabledDate={(current) => {
                        // const minCaloriesDay = props.minCaloriesDay === 1 ? 0 : props.minCaloriesDay;
                        return current && current < moment().endOf('day'); // moment().add(minCaloriesDay, 'days')
                      }}
                      value={
                        props.responseObj[render.value]
                          ? moment(props.responseObj[render.value].value)
                          : null
                      }
                      format={'MM/DD/YYYY'}
                      onChange={(e) => {
                        props.handleChange(
                          e,
                          render.value,
                          props.activeQuestion.addOnAfter &&
                            Object.values(props.activeQuestion.addOnAfter).find(
                              (value) => value.active === true
                            ).key
                        );
                        setError(
                          render.validate(
                            e,
                            null,
                            render.value === 'byWhen'
                              ? props.responseObj.goalWeight
                              : null
                          )
                        );
                      }}
                      allowClear={false}
                      showToday={false}
                    />
                  </div>
                </div>
              );
            } else if (componentType === 'Tabs') {
              return (
                <div>
                  <div className='flex flex-center-aligned'>
                    {!shouldHideFormName && (
                    <p className='form-name'>{render.type}</p>
                  )}
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          {/* <BsQuestionCircleFill style={{ fontSize: '12px', margin: '0 0 1px 3px' }} /> */}
                          <BulbFilled
                            style={{
                              fontSize: '18px',
                              color: '#BDBDBD',
                              margin: '0 0 1px 3px',
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <div className='flex'>
                    {component.options.map((option) => (
                      <div
                        className={`option ${option.active ? 'active' : ''}`}
                        onClick={() => {
                          props.handleChange(option, component.type);
                          setError(
                            render.validate(
                              null,
                              null,
                              props.responseObj.byWhen
                            )
                          );
                        }}
                      >
                        <p className='option-text'>{option.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            } else if (componentType === 'TextArea') {
              return (
                <div style={{ display: !render.active ? 'none' : '' }}>
                  <div className='flex flex-center-aligned'>
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          style={{ display: !render.popover && 'none' }}
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          <BsQuestionCircleFill
                            style={{ fontSize: '12px', margin: '0 0 1px 3px' }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <div
                    className='flex flex-center-aligned'
                    style={{ marginBottom: 10 }}
                  >
                    <TextArea
                      className={`${
                        render.className ? render.className : ''
                      } ant-textarea`}
                      key={render.type}
                      autoFocus={render.autoFocus}
                      onChange={(e) => {
                        props.handleChange(e, render.value);
                        setError(
                          render.validate(
                            e.target.value,
                            props.units,
                            render.value === 'secondaryGoals'
                              ? props.responseObj.secondaryGoals
                              : render.value === 'trainingActivity'
                              ? props.responseObj.trainingActivity
                              : props.responseObj.secondaryGoals
                          )
                        );
                      }}
                      placeholder={render.type}
                      value={
                        props.responseObj[render.value] &&
                        props.responseObj[render.value].value
                      }
                      autoSize={{ minRows: 4, maxRows: 4 }}
                    />
                  </div>
                </div>
              );
            } else if (componentType == 'HeightFtAndIc') {
              return (
                <div style={{ display: !render.active ? 'none' : '' }}>
                  <div className='flex flex-center-aligned'>
                    {!shouldHideFormName && (
                    <p className='form-name'>{render.type}</p>
                  )}
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          style={{ display: !render.popover && 'none' }}
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          {/* <BsQuestionCircleFill style={{ fontSize: '12px', margin: '0 0 1px 3px' }} /> */}
                          <BulbFilled
                            style={{
                              fontSize: '18px',
                              color: '#BDBDBD',
                              margin: '0 0 1px 3px',
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <div
                    className='flex flex-center-aligned'
                    style={{ marginBottom: 10 }}
                  >
                    {render.value === 'heightFt' && (
                      <Select
                        style={{ width: '100%' }}
                        placeholder='Feet'
                        className='select-input'
                        onChange={(value) => {
                          props.handleChange(value, render.value);
                          setError(
                            render.validate(
                              value,
                              props.units,
                              props.responseObj.heightIn
                            )
                          );
                        }}
                        value={
                          props.responseObj.heightFt
                            ? props.responseObj.heightFt.value
                            : undefined
                        }
                      >
                        {heigthFtOptions.map((height, i) => (
                          <Option
                            className='select-option'
                            key={height.value.toString()}
                            value={height.value}
                          >
                            {height.value}
                          </Option>
                        ))}
                      </Select>
                    )}
                    {render.value === 'heightIn' && (
                      <Select
                        style={{ width: '100%' }}
                        placeholder='Inches'
                        className='select-input'
                        onChange={(value) => {
                          props.handleChange(value, render.value);
                          setError(
                            render.validate(
                              value,
                              props.units,
                              props.responseObj.heightFt
                            )
                          );
                        }}
                        value={
                          props.responseObj.heightIn
                            ? props.responseObj.heightIn.value
                            : undefined
                        }
                      >
                        {heigthInOptions.map((height, i) => (
                          <Option
                            className='select-option'
                            key={height.value.toString()}
                            value={height.value}
                          >
                            {height.value}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>
                </div>
              );
            } else if (componentType === 'MacroSelect') {
              const hasChangedOption = props.activeQuestion.options
                ? props.activeQuestion.options.find((option) => option.active)
                : false;
              var selectedValue = props.activeQuestion.options;
              if (props.responseObj[props.activeQuestion.type]) {
                selectedValue = props.responseObj[props.activeQuestion.type];
              } else if (
                props.auth.assessmentProgress &&
                props.auth.assessmentProgress.weightTraningexprience
              ) {
                selectedValue =
                  props.auth.assessmentProgress[props.activeQuestion.type];
              }
              return (
                <React.Fragment>
                  <div className='flex flex-column'>
                    {props.activeQuestion.options &&
                      props.activeQuestion.options.map((option) => (
                        <div
                          className={`option flex-column card-piechart ${
                            option.active ||
                            (!hasChangedOption &&
                              props.auth.assessmentProgress &&
                              props.auth.assessmentProgress[
                                props.activeQuestion.type
                              ] &&
                              props.auth.assessmentProgress[
                                props.activeQuestion.type
                              ].text === option.text)
                              ? 'active'
                              : ''
                          }`}
                          onClick={() => {
                            props.handleChange(
                              option,
                              props.activeQuestion.type
                            );
                            setError(
                              props.activeQuestion.validate(
                                option.macros,
                                option.text
                              )
                            );
                          }}
                        >
                          <div className='flex flex-center-aligned w-100 custom-radio'>
                            {option.macros && (
                              <PieChart
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  marginRight: '15px',
                                }}
                                data={[
                                  {
                                    title: 'One',
                                    value: option.macros.protein,
                                    color: 'var(--primary, #8b5cf6)',
                                  },
                                  {
                                    title: 'Two',
                                    value: option.macros.carb,
                                    color: '#06b6d4',
                                  },
                                  {
                                    title: 'Three',
                                    value: option.macros.fat,
                                    color: '#10b981',
                                  },
                                ]}
                                lineWidth={100}
                                paddingAngle={5}
                              />
                            )}

                            {option.macros && (
                              <div>
                                <p className='option-text text-left'>
                                  {option.text}
                                </p>
                                <div className='flex space-between'>
                                  <div className='flex flex-center-aligned'>
                                    <Badge
                                      className='assessment-badge'
                                      color={'var(--primary, #8b5cf6)'}
                                      text={`${option.macros.protein}% protein`}
                                    />
                                  </div>
                                  <div className='flex flex-center-aligned'>
                                    <Badge
                                      className='assessment-badge'
                                      color={'#06b6d4'}
                                      text={`${option.macros.carb}% carb`}
                                    />
                                  </div>
                                  <div className='flex flex-center-aligned'>
                                    <Badge
                                      className='assessment-badge'
                                      color={'#10b981'}
                                      text={`${option.macros.fat}% fat`}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          {option.text === 'Custom' && (
                            <div className='custom-chart mt-2'>
                              <p>{option.subtext}</p>
                              <div className='flex space-between w-100'>
                                <div className='macros-input'>
                                  <small>Protein</small>
                                  <Input
                                    maxLength={2}
                                    onChange={(e) => {
                                      props.handleChange(
                                        e,
                                        'Custom',
                                        'protein'
                                      );
                                      setError(
                                        props.activeQuestion.validate(
                                          {
                                            protein: e.target.value,
                                            carb: option.macros.carb,
                                            fat: option.macros.fat,
                                          },
                                          option.text
                                        )
                                      );
                                    }}
                                    defaultValue={option.macros.protein}
                                    value={
                                      selectedValue && selectedValue.protein
                                        ? selectedValue.macros.protein
                                        : option.macros.protein
                                    }
                                    onFocus={(e) => e.target.select()}
                                  />
                                </div>
                                <div className='macros-input'>
                                  <small>Carb</small>
                                  <Input
                                    maxLength={2}
                                    onChange={(e) => {
                                      props.handleChange(e, 'Custom', 'carb');
                                      setError(
                                        props.activeQuestion.validate(
                                          {
                                            protein: option.macros.protein,
                                            carb: e.target.value,
                                            fat: option.macros.fat,
                                          },
                                          option.text
                                        )
                                      );
                                    }}
                                    defaultValue={option.macros.carb}
                                    value={
                                      selectedValue && selectedValue.carb
                                        ? selectedValue.macros.carb
                                        : option.macros.carb
                                    }
                                    onFocus={(e) => e.target.select()}
                                  />
                                </div>
                                <div className='macros-input'>
                                  <small>Fat</small>
                                  <Input
                                    maxLength={2}
                                    onChange={(e) => {
                                      props.handleChange(e, 'Custom', 'fat');
                                      setError(
                                        props.activeQuestion.validate(
                                          {
                                            protein: option.macros.protein,
                                            carb: option.macros.carb,
                                            fat: e.target.value,
                                          },
                                          option.text
                                        )
                                      );
                                    }}
                                    defaultValue={option.macros.fat}
                                    value={
                                      selectedValue && selectedValue.fat
                                        ? selectedValue.macros.fat
                                        : option.macros.fat
                                    }
                                    onFocus={(e) => e.target.select()}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </React.Fragment>
              );
            } else if (componentType === 'CustomCheckbox') {
              const responseValue = props.responseObj[render.value];
              let { selectedOptions = [], otherDescription = null } = responseValue &&
                responseValue.value
                ? responseValue.value
                : {};
              const onCkChange = (checkedValues) => {
                props.handleChange(
                  {
                    selectedOptions: checkedValues,
                    otherDescription: otherDescription,
                  },
                  render.value
                );
                setError(render.validate(checkedValues, otherDescription));
              };
              const handleTXChange = (e) => {
                props.handleChange(
                  {
                    selectedOptions: selectedOptions,
                    otherDescription: e.target.value,
                  },
                  render.value
                );
                setError(render.validate(selectedOptions, e.target.value));
              };
              return (
                <div className='text-left'>
                  {(() => {
                    const opts = render.options || [];
                    const hasNoneFirst = opts[0] && opts[0].value === 'None';
                    const [none, ...restOptions] = hasNoneFirst ? [opts[0], ...opts.slice(1)] : [null, ...opts];
                    if (!none && opts.length === 0) return null;
                    if (!hasNoneFirst) {
                      return (
                        <>
                          <Checkbox.Group
                            style={{ width: '100%' }}
                            onChange={onCkChange}
                            value={selectedOptions}
                          >
                            {opts.map((op) => (
                              <Checkbox
                                className='custom-checkbox'
                                key={op.key}
                                value={op.value}
                              >
                                {op.text}
                              </Checkbox>
                            ))}
                          </Checkbox.Group>
                          {selectedOptions.includes('Other') && (
                            <TextArea
                              rows={3}
                              placeholder='Type here...'
                              className='ant-textarea'
                              onChange={handleTXChange}
                              value={otherDescription}
                            />
                          )}
                        </>
                      );
                    }
                    return (
                      <>
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          onChange={onCkChange}
                          value={selectedOptions}
                        >
                          <Checkbox
                            className='custom-checkbox'
                            key={none.key}
                            value={none.value}
                          >
                            {none.text}
                          </Checkbox>
                        </Checkbox.Group>
                        <hr
                          style={{
                            borderColor: '#E0E0E0',
                            marginBottom: '15px',
                          }}
                        ></hr>
                        {selectedOptions.includes(none.value) ? (
                          ''
                        ) : (
                          <>
                            <Checkbox.Group
                              style={{ width: '100%' }}
                              onChange={onCkChange}
                              value={selectedOptions}
                            >
                              {restOptions.map((op) => (
                                <Checkbox
                                  className='custom-checkbox'
                                  key={op.key}
                                  value={op.value}
                                >
                                  {op.text}
                                </Checkbox>
                              ))}
                            </Checkbox.Group>
                            {selectedOptions.includes('Other') && (
                              <TextArea
                                rows={3}
                                placeholder='Type here...'
                                className='ant-textarea'
                                onChange={handleTXChange}
                                value={otherDescription}
                              />
                            )}
                          </>
                        )}
                      </>
                    );
                  })()}
                  {/* {render.options.map(option =>
                    (option.value === "None") ?
                      <>
                        <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                          <Checkbox className="custom-checkbox" value="None">None</Checkbox>
                        </Checkbox.Group>
                        <hr style={{ borderColor: "#E0E0E0", marginBottom: "15px" }}></hr>
                      </>
                      :
                      <>
                        <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                          <Checkbox className="custom-checkbox" value="High blood pressure">High blood pressure</Checkbox>
                          <Checkbox className="custom-checkbox" value="Diabetes">Diabetes</Checkbox>
                          <Checkbox className="custom-checkbox" value="Testosterone deficiency">Testosterone deficiency</Checkbox>
                          <Checkbox className="custom-checkbox" value="Heart disease or stroke">Heart disease or stroke</Checkbox>
                          <Checkbox className="custom-checkbox" value="Osteoarthritis">Osteoarthritis</Checkbox>
                          <Checkbox className="custom-checkbox" value="Other">Other</Checkbox>
                        </Checkbox.Group>
                        <TextArea rows={3} placeholder="Type here..." maxLength={6} className="ant-textarea" />
                      </>
                  )} */}
                </div>
              );
            } else if (componentType === 'SliderSelect') {
              var selectedValue = render.defaultValue;
              if (props.responseObj.weightTraningexprience) {
                selectedValue = props.responseObj.weightTraningexprience.key;
              } else if (
                props.auth.assessmentProgress &&
                props.auth.assessmentProgress.weightTraningexprience
              ) {
                selectedValue =
                  props.auth.assessmentProgress.weightTraningexprience.key;
              }
              const onAfterChange = (value) => {
                props.handleChange(
                  {
                    key: value,
                    text: render.marks[value],
                    value: render.marks[value],
                    info: render.tooltips[value],
                  },
                  props.activeQuestion.type
                );
                setError(props.activeQuestion.validate());
                setTermsOfWeightTraningexprience(render.tooltips[value]);
              };
              return (
                <div className='custom-ant-slider'>
                  <p>
                    {termsOfWeightTraningexprience
                      ? termsOfWeightTraningexprience
                      : render.tooltips[render.defaultValue]}
                  </p>
                  <Slider
                    marks={render.marks}
                    min={render.min}
                    max={render.max}
                    step={render.step}
                    defaultValue={selectedValue}
                    tooltipVisible={render.tooltipVisible}
                    onAfterChange={onAfterChange}
                  />
                  {/* <Slider style={{ backgroundImage: "url( " + require("../../assets/images/slider-bar-image.svg") + ")" }} marks={render.marks} min={render.min} max={render.max} step={render.step} defaultValue={selectedValue} tooltipVisible={render.tooltipVisible} onAfterChange={onAfterChange} /> */}
                  {/* <Slider marks={render.marks} min={render.min} max={render.max} step={render.step} defaultValue={render.defaultValue} value={selectedValue} tooltipVisible={render.tooltipVisible} onAfterChange={onAfterChange} />                   */}
                  {/* <img src={require("../../assets/images/slider-bar-image.svg")} style={{width: "100%"}} /> */}
                </div>
              );
            } else if (componentType === 'InputAutoCompleteMap') {
              return (
                <div style={{ display: !render.active ? 'none' : '' }}>
                  <div className='flex flex-center-aligned'>
                    <p className='form-name'>{render.type} </p>
                    {render.popover && (
                      <div className='assessment-popover'>
                        <Popover
                          style={{ display: !render.popover && 'none' }}
                          placement='top'
                          title={render.popover.title}
                          content={render.popover.text}
                          trigger='click'
                        >
                          {/* <BsQuestionCircleFill style={{ fontSize: '12px', margin: '0 0 1px 3px' }} /> */}
                          <BulbFilled
                            style={{
                              fontSize: '18px',
                              color: '#BDBDBD',
                              margin: '0 0 1px 3px',
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </div>
                  <div
                    className='flex flex-center-aligned'
                    style={{ marginBottom: 10 }}
                  >
                    <LocationInput
                      name='currentLocation'
                      id='location'
                      placeholder='Enter Location'
                      type={render.inputType ? render.inputType : 'text'}
                      className={render.className}
                      key={render.type}
                      autoFocus={render.autoFocus}
                      maxLength={render.maxLength}
                      onChange={(e) => {
                        props.handleChange(e, render.value);
                        setError(render.validate(e));
                      }}
                      defaultValue={
                        props.responseObj[render.value] &&
                        props.responseObj[render.value].location
                      }
                      // defaultValue={
                      //   props.responseObj[render.value] &&
                      //   props.responseObj[render.value].value
                      // }
                    />
                  </div>
                </div>
              );
            } else if (componentType === 'newPassword') {
              return (
                <div className='flex flex-column' style={{ marginBottom: 10 }}>
                  {!shouldHideFormName && (
                    <p className='form-name'>{render.type}</p>
                  )}
                  <PasswordField
                    key={render.type}
                    onChange={(e) => {
                      props.handleChange(e, render.value);
                      setError(
                        render.validate(
                          e.target.value,
                          render.value === 'newPassword'
                            ? props.responseObj.confirmNewPassword
                            : props.responseObj.newPassword
                        )
                      );
                    }}
                    defaultValue={
                      props.responseObj[render.value] &&
                      props.responseObj[render.value].value
                    }
                  />
                </div>
              );
            } else {
              let { selectedOptions = [], otherDescription = null } = props
                .responseObj[component.type]
                ? props.responseObj[component.type].value
                : {};
              const onCkChange = (checkedValues) => {
                props.handleChange(
                  {
                    selectedOptions: checkedValues,
                    otherDescription: otherDescription,
                  },
                  render.value
                );
                setError(render.validate(checkedValues, otherDescription));
              };
              const handleTXChange = (e) => {
                props.handleChange(
                  {
                    selectedOptions: selectedOptions,
                    otherDescription: e.target.value,
                  },
                  render.value
                );
                setError(render.validate(selectedOptions, e.target.value));
              };
              return (
                <div className='text-left'>
                  {(() => {
                    return (
                      <>
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          onChange={onCkChange}
                          value={selectedOptions}
                        >
                          {render.options.map((op) => (
                            <Checkbox
                              className='custom-checkbox'
                              key={op.key}
                              value={op.value}
                            >
                              {op.text}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                        {selectedOptions.includes('Other') && (
                          <TextArea
                            rows={3}
                            placeholder='Type here...'
                            className='ant-textarea'
                            onChange={handleTXChange}
                            value={otherDescription}
                          />
                        )}
                      </>
                    );
                  })()}
                </div>
              );
            }
          });
        });
    } else {
      const hasChangedOption = props.activeQuestion.options.find(
        (option) => option.active
      );
      const qType = props.activeQuestion.type;
      const isActivity = qType === 'activityLevel';
      return (
        <React.Fragment>
          <div className='flex flex-column'>
            {props.activeQuestion.options &&
              props.activeQuestion.options.map((option, idx) => {
                const selected =
                  option.active ||
                  (!hasChangedOption &&
                    props.auth.assessmentProgress &&
                    props.auth.assessmentProgress[qType] &&
                    props.auth.assessmentProgress[qType].key === option.key);
                const meta = OPT_META[qType] && OPT_META[qType][option.value];
                const desc =
                  option.info ||
                  (option.popover && option.popover.text) ||
                  '';
                return (
                  <button
                    key={option.key}
                    type='button'
                    className={`option ${selected ? 'active' : ''}`}
                    onClick={() => {
                      props.handleChange(option, qType);
                      setError(
                        props.activeQuestion.validate(
                          option.macros,
                          option.text
                        )
                      );
                    }}
                  >
                    {isActivity ? (
                      <span className='bars'>
                        {[1, 2, 3, 4, 5].map((b) => (
                          <span
                            key={b}
                            className={b <= idx + 1 ? 'on' : ''}
                            style={{ height: `${b * 16 + 12}%` }}
                          />
                        ))}
                      </span>
                    ) : meta ? (
                      <span
                        className='ico'
                        style={{
                          background: meta.color + '1f',
                          color: meta.color,
                        }}
                      >
                        {OPT_ICONS[meta.icon]}
                      </span>
                    ) : null}
                    <span className='label'>
                      <span className='t'>{option.text}</span>
                      {desc ? <span className='d'>{desc}</span> : null}
                    </span>
                    <span className='radio'>{OPT_ICONS.check}</span>
                  </button>
                );
              })}
          </div>
        </React.Fragment>
      );
    }
  };
  return (
    <React.Fragment>
      {props.activeQuestion && (
        <div className='assessment-questions'>
          {EYEBROW[props.activeQuestion.type] && (
            <p className='assessment-eyebrow'>
              {EYEBROW[props.activeQuestion.type]}
            </p>
          )}
          <p className='assessment-question-title'>
            {props.activeQuestion.question}
          </p>
          {props.activeQuestion.subtitle && (
            <p className='assessment-sub'>
              {props.activeQuestion.subtitle.text}
            </p>
          )}
          {renderQuestion()}
          <div className='mb-3'>
            {Boolean(error) && <Alert message={<p>{error}</p>} type='error' />}
          </div>

          <div className='btn-wrap '>
            <div className='flex space-between next-prev-btn'>
              {props.activeQuestion.key > 1 && (
                  <Button
                    className='flex flex-center-aligned assessment-back-btn'
                    onClick={(e) =>
                      props.handleProgress(e, 'back', props.activeQuestion)
                    }
                    disabled={
                      props.auth.assessmentSubmitLoader ? 'disabled' : ''
                    }
                  >
                    <span className='mr-1'>
                      <i class='far fa-arrow-left'></i>
                    </span>
                    <p style={{ fontSize: '18px' }}>Back</p>
                  </Button>
                )}
              <div className='flex flex-center-aligned enter-next-group'>
                {props.activeQuestion.button && !Boolean(error) && (
                  <span className='assessment-enter-hint'>
                    Press <kbd>Enter</kbd> ↵ to continue
                  </span>
                )}
                {props.activeQuestion.button && (
                  <Button
                    className='assessment-button'
                    onClick={(e) => {
                      props.handleProgress(e, null, props.activeQuestion);
                    }}
                    disabled={Boolean(error) || props.auth.assessmentSubmitLoader}
                    loading={
                      props.loadingCalculation && props.errors.length === 0
                    }
                  >
                    {props.activeQuestion.key === props.totalQuestions
                      ? 'Submit'
                      : 'Next '}
                    {props.activeQuestion.key !== props.totalQuestions ? (
                      <span className='ml-1'>
                        <i className='far fa-arrow-right'></i>
                      </span>
                    ) : null}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
